import { render, staticRenderFns } from "./EditPractice.vue?vue&type=template&id=5d1d1d5c"
import script from "./EditPractice.vue?vue&type=script&lang=js"
export * from "./EditPractice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports